import { ArticleTemplate } from './article';

export default ArticleTemplate;
